import { AppLoader, getRoutes } from '@bicameral/dealerconnect-core/components';
import { appExtInfo as legacy } from '@bicameral/dealerconnect-legacy';
import { appExtInfo as toolManager } from '@bicameral/dealerconnect-tool-manager';
import { appExtInfo as dlrExp } from '@bicameral/dealerconnect-delivery-experience';
import { systemAdminApp } from '@bicameral/dealerconnect-core/modules/SystemSettings';
import { appConfig, commonExtInfo } from '@bicameral/dealerconnect-core';
import { selfServiceExtInfo } from '@bicameral/dealerconnect-core/modules/SelfService';

const enabledModules = appConfig.modules ?? [];
const apps = [commonExtInfo, systemAdminApp, legacy, toolManager, selfServiceExtInfo, dlrExp].filter(
  app => enabledModules.length === 0 || appConfig.modules.indexOf(app.id) !== -1,
);
const routes = getRoutes('en-CA', appConfig.defaultTheme, apps);

const App = () => {
  return <AppLoader routes={routes} />;
};

export default App;
